export const permissionsGroupNames = [
  'Super Admin',
  'IT Admin',
  'Support Standard',
  'Customer Success',
  'Work Order Creator',
  'Work Order Manager',
  'Warehouse Partner',
  'End User Software Contact',
  'Billing Contact',
  'Shipping Contact',
  'Sales Order Manager',
  'View Only Sales Order Manager',
  'Temporary Sales Order Manager',
] as const;
